/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */

'use strict';

var warning = require("fbjs/lib/warning");
var implementation = null;
function inject(impl) {
  process.env.NODE_ENV !== "production" ? warning(implementation !== null, 'Relay HooksImplementation was injected twice.') : void 0;
  implementation = impl;
}
function get() {
  return implementation;
}
module.exports = {
  inject: inject,
  get: get
};